module.exports = __webpack_public_path__ + "static/media/4.59a3a63d.jpg";